import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';

function LandingAI() {
  const navigate = useNavigate();
  const [cgvAcceptees, setCgvAcceptees] = useState(false);

  // 🚀 LE MOTEUR DE REDIRECTION (Aligné avec ton architecture backend)
  const choisirPlan = (plan) => {
    if (plan.priceId && !cgvAcceptees) {
      alert("⚠️ Action requise : Veuillez cocher la case d'acceptation des conditions légales pour continuer.");
      return;
    }
    
    // 1. On mémorise le plan
    localStorage.setItem('planChoisi', plan.title);
    
    // 2. On stocke le bon ID Stripe et le type (pour Register.js)
    if (plan.priceId) {
      localStorage.setItem('pendingPriceId', plan.priceId);
      const isSubscription = plan.type && plan.type.includes('mois');
      localStorage.setItem('pendingPlanType', isSubscription ? "subscription" : "payment");
    } else {
      localStorage.removeItem('pendingPriceId');
      localStorage.removeItem('pendingPlanType'); 
    }

    // 3. On dirige TOUT LE MONDE vers l'inscription d'abord
    navigate('/register');
  };

  return (
    <div style={{ fontFamily: '"Inter", sans-serif', color: '#FFFFFF', background: '#0f172a', minHeight: '100vh' }}>
      
      {/* NAVIGATION RAPIDE */}
      <div style={{ background: '#1e293b', padding: '15px', textAlign: 'center', borderBottom: '1px solid #334155' }}>
        <span style={{ color: '#94a3b8', marginRight: '15px' }}>Découvrez aussi notre expertise classique :</span>
        <Link to="/" style={{ color: '#38bdf8', textDecoration: 'none', fontWeight: 'bold' }}>
          Retour à l'Audit Cyber & RGPD 🛡️
        </Link>
      </div>

      {/* HERO SECTION IA */}
      <header style={{ padding: '80px 20px', textAlign: 'center' }}>
        <div style={{ maxWidth: '800px', margin: '0 auto' }}>
          <div style={{ display: 'inline-block', background: 'rgba(139, 92, 246, 0.2)', color: '#c084fc', padding: '6px 16px', borderRadius: '20px', fontSize: '14px', fontWeight: 'bold', marginBottom: '24px', border: '1px solid #8b5cf6' }}>
            🤖 Nouveau : AI Act & GenAI Compliance
          </div>
          <h1 style={{ fontSize: '48px', fontWeight: '900', margin: '0 0 24px 0', lineHeight: '1.2', background: 'linear-gradient(to right, #c084fc, #38bdf8)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>
            Vos IA vous exposent-elles à des sanctions pénales ?
          </h1>
          <p style={{ fontSize: '20px', color: '#cbd5e1', marginBottom: '40px' }}>
            Deepfakes, Prompt Injection, Biais algorithmiques. Pilotez votre conformité à l'AI Act européen avec notre audit spécialisé.
          </p>
        </div>
      </header>

      {/* OFFRES IA */}
      <section style={{ padding: '60px 20px', textAlign: 'center' }}>
        <h2 style={{ fontSize: '32px', fontWeight: 'bold', marginBottom: '20px' }}>Choisissez votre niveau de protection IA</h2>
        
        {/* LE SUPER COPYWRITING & LA RÉASSURANCE */}
        <div style={{ textAlign: 'center', maxWidth: '900px', margin: '0 auto 50px auto', padding: '0 20px' }}>
          <p style={{ fontSize: '20px', color: '#cbd5e1', lineHeight: '1.6', fontWeight: '600', marginBottom: '30px' }}>
            Prenez de meilleures décisions grâce à un audit intelligent instantané.<br/>
            <span style={{ color: '#c084fc' }}>Des données claires. Des recommandations exploitables. Des résultats mesurables.</span>
          </p>

          <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', gap: '15px 30px', backgroundColor: '#1e293b', padding: '20px', borderRadius: '8px', border: '1px solid #334155' }}>
            <span style={{ fontSize: '15px', color: '#f8fafc', fontWeight: '500' }}><span style={{ color: '#2ecc71', marginRight: '8px' }}>✔</span> Analyse instantanée</span>
            <span style={{ fontSize: '15px', color: '#f8fafc', fontWeight: '500' }}><span style={{ color: '#2ecc71', marginRight: '8px' }}>✔</span> Rapport détaillé</span>
            <span style={{ fontSize: '15px', color: '#f8fafc', fontWeight: '500' }}><span style={{ color: '#2ecc71', marginRight: '8px' }}>✔</span> Recommandations concrètes</span>
            <span style={{ fontSize: '15px', color: '#f8fafc', fontWeight: '500' }}><span style={{ color: '#2ecc71', marginRight: '8px' }}>✔</span> Sans rendez-vous</span>
            <span style={{ fontSize: '15px', color: '#f8fafc', fontWeight: '500' }}><span style={{ color: '#2ecc71', marginRight: '8px' }}>✔</span> 100% en ligne</span>
            <span style={{ fontSize: '15px', color: '#f8fafc', fontWeight: '500' }}><span style={{ color: '#2ecc71', marginRight: '8px' }}>✔</span> Résultats exploitables immédiatement</span>
          </div>
        </div>

        {/* CASE À COCHER LÉGALE */}
        <div style={{ marginBottom: '50px', background: 'rgba(255,255,255,0.05)', padding: '20px', borderRadius: '8px', display: 'inline-block', maxWidth: '800px', border: cgvAcceptees ? '2px solid #8b5cf6' : '1px dashed #475569' }}>
          <label style={{ cursor: 'pointer', display: 'flex', alignItems: 'flex-start', gap: '15px', fontSize: '14px', textAlign: 'left' }}>
            <input type="checkbox" checked={cgvAcceptees} onChange={(e) => setCgvAcceptees(e.target.checked)} style={{ width: '24px', height: '24px' }} />
            <span>J'accepte les Conditions Générales et je renonce à mon droit de rétractation (Art. L221-28) pour accéder immédiatement aux outils.</span>
          </label>
        </div>

        <div style={{ display: 'flex', gap: '30px', flexWrap: 'wrap', justifyContent: 'center' }}>
          {[
            { title: 'Test de Choc IA', price: '0€', type: 'gratuit', feats: ['10 questions clés', 'Gouvernance & Transparence', 'Score de risque IA'], color: '#64748b', priceId: null },
            { title: 'Diagnostic Légal', price: '149€', type: 'unique', feats: ['40 questions AI Act', 'Classification des risques', 'Rapport juridique'], color: '#38bdf8', priceId: 'price_1TUixW1KS1vyXKN3KT2EjFxI' },
            { title: 'Audit 360° & Deepfake', price: '390€', type: 'unique', feats: ['90 questions expertes', 'Tests Prompt Injection', 'Module Deepfake', 'Plan d\'action complet'], color: '#8b5cf6', badge: 'LE PLUS POPULAIRE', priceId: 'price_1TUj4d1KS1vyXKN3v6zVRLFc' },
            { title: 'SOC IA Continu', price: '490€/m', type: 'mois', feats: ['120+ questions (Illimité)', 'Surveillance continue', 'Gestion des incidents IA', 'Accompagnement VIP'], color: '#ec4899', priceId: 'price_1TUjFS1KS1vyXKN3JK3hU2mr' }
          ].map((plan, i) => (
            <div key={i} style={{ background: '#1e293b', border: `2px solid ${plan.color}`, borderRadius: '16px', padding: '30px', width: '280px', textAlign: 'left', position: 'relative', display: 'flex', flexDirection: 'column' }}>
              {plan.badge && <div style={{ position: 'absolute', top: '-12px', left: '50%', transform: 'translateX(-50%)', background: plan.color, color: 'white', padding: '4px 12px', borderRadius: '12px', fontSize: '11px', fontWeight: 'bold' }}>{plan.badge}</div>}
              <h3 style={{ fontSize: '22px', marginBottom: '10px' }}>{plan.title}</h3>
              <div style={{ fontSize: '36px', fontWeight: 'bold', color: plan.color, marginBottom: '20px' }}>{plan.price}</div>
              <ul style={{ listStyle: 'none', padding: 0, marginBottom: '30px', color: '#cbd5e1', flex: 1 }}>
                {plan.feats.map((f, j) => <li key={j} style={{ marginBottom: '10px' }}>✓ {f}</li>)}
              </ul>
              <button onClick={() => choisirPlan(plan)} style={{ width: '100%', padding: '15px', background: plan.price === '0€' ? 'transparent' : plan.color, color: 'white', border: plan.price === '0€' ? `1px solid ${plan.color}` : 'none', borderRadius: '8px', fontWeight: 'bold', cursor: 'pointer', opacity: (plan.priceId && !cgvAcceptees) ? 0.5 : 1 }}>
                {plan.priceId ? "Sélectionner" : "Commencer gratuit"}
              </button>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}

export default LandingAI;